import React from 'react';
import '../CSS/ContactUs.css';
import { TextField, Button } from '@mui/material';

const ContactUs: React.FC = () => {
  return (
    <div className="contact-us-container">
      <div className="contact-us-hero">
        <div className="contact-us-hero-text">
          Connect With Us – Your Questions, Our Answers!
        </div>
      </div>
      {/* Contact Form Section */}
      <form className="contact-us-form">
        <div className="contact-us-form-title">Fill out the form below</div>
        <fieldset className="contact-us-fieldset">
          <div className="contact-us-row">
            <div className="contact-us-col">
              <label htmlFor="firstName">First Name<span className="contact-us-required">*</span></label>
              <TextField id="firstName" name="firstName" variant="outlined" required fullWidth size="medium" className="contact-us-input" />
            </div>
            <div className="contact-us-col">
              <label htmlFor="lastName">Last Name<span className="contact-us-required">*</span></label>
              <TextField id="lastName" name="lastName" variant="outlined" required fullWidth size="medium" className="contact-us-input" />
            </div>
          </div>
          <div className="contact-us-row">
            <div className="contact-us-col">
              <label htmlFor="email">Email<span className="contact-us-required">*</span></label>
              <TextField id="email" name="email" type="email" variant="outlined" required fullWidth size="medium" className="contact-us-input" />
            </div>
            <div className="contact-us-col">
              <label htmlFor="phone">Phone<span className="contact-us-required">*</span></label>
              <TextField id="phone" name="phone" type="tel" variant="outlined" required fullWidth size="medium" className="contact-us-input" placeholder="+ 1" />
            </div>
          </div>
          <div className="contact-us-row contact-us-row-message">
            <div className="contact-us-col contact-us-col-message">
              <label htmlFor="message">Message<span className="contact-us-required">*</span></label>
              <TextField id="message" name="message" variant="outlined" required fullWidth multiline minRows={6} className="contact-us-input" />
            </div>
          </div>
        </fieldset>
        <Button type="submit" variant="contained" className="contact-us-submit-btn">Submit</Button>
      </form>
    </div>
  );
};

export default ContactUs; 